export default __webpack_public_path__ + "static/media/birthday.b883e492.png";